<template>
    <modal-base :pacifier="false" :hide-title="true">
        <template #preheader>
            <div class="text-center">
                <div class="font-sans bg-brand-teal-light text-white py-1 px-3 rounded-[2rem] inline-flex mx-auto items-center uppercase font-bold tracking-wide text-sm">
                        <span>
                            <i :class="isBusinessHours ? 'bg-brand-lime animate-pulse' : 'bg-red-400'" class="rounded-full inline-block w-2 h-2 mr-2"></i>
                        </span>
                    <span>Current Status: {{ isBusinessHours ? 'Online' : 'Offline' }}</span>
                </div>
            </div>
        </template>

        <template #extra>
            <div v-if="isBusinessHours" class="text-4xl font-medium font-access-legal tracking-tight mb-3 text-center text-brand-teal">
                Select Your Next Step Below:
            </div>

            <div class="mt-6 text-center">
                <div class="flex flex-col lg:flex-row items-center justify-center gap-4">

                    <button class="font-medium w-full sm:w-auto bg-brand-lime text-brand-teal rounded-[3rem] py-4 flex items-center justify-center px-4 sm:px-8 text-left"
                        type="submit"
                        @click="call"
                        v-if="canInitiateCall">
                        <i class="far fa-phone text-2xl pr-3 sm:pr-6"></i>
                        <div class="w-full">
                            <span class="block text-base sm:text-xl leading-[1.1]">Call and Connect Me Now</span>
                        </div>
                        <svg class="hidden sm:block pl-6 w-auto fill-current h-3" viewBox="0 0 9 8" xmlns="http://www.w3.org/2000/svg"><path d="M0.260254 3.28369H6.96973L4.11963 0.395508H5.71924L8.79785 3.48682V4.24219L5.71924 7.32715H4.11963L6.96973 4.42627H0.260254V3.28369Z"></path></svg>
                    </button>

                    <button v-if="hasCalendly" class="font-medium w-full sm:w-auto text-left bg-brand-teal-light text-white rounded-[3rem] py-4 flex items-center justify-center px-4 sm:px-8"
                        type="submit"
                        @click="schedule">
                        <i class="far fa-calendar text-2xl pr-3 sm:pr-6"></i>
                        <div class="w-full">
                            <span class="block text-base sm:text-xl leading-[1.1]">{{ scheduleButtonText }}</span>
                        </div>
                        <svg class="hidden sm:block pl-6 w-auto fill-current h-3" viewBox="0 0 9 8" xmlns="http://www.w3.org/2000/svg"><path d="M0.260254 3.28369H6.96973L4.11963 0.395508H5.71924L8.79785 3.48682V4.24219L5.71924 7.32715H4.11963L6.96973 4.42627H0.260254V3.28369Z"></path></svg>
                    </button>
                </div>
                <p v-if="isBusinessHours" class="text-center mt-4">Or We Will Call You from <span class="whitespace-nowrap"><span class="font-bold">{{ directConnectFrom }}</span> {{ countdownText }}.</span></p>
            </div>
        </template>
    </modal-base>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                countdownInterval: null,
                countdown: null,
            }
        },
        mounted() {
            if (this.isUnactionable) {
                this.$store.commit('started', false);
            }
            const delay = this.directConnectFirstCallDelay;
            if (! Number.isFinite(delay) || delay <= 0) {
                this.countdown = 0;
                return;
            }

            this.countdown = delay;
            this.countdownInterval = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    clearInterval(this.countdownInterval);
                }
            }, 1000)
        },
        unmounted() {
            clearInterval(this.countdownInterval);
        },
        computed: {
            countdownText() {
                if (this.countdown === null) {
                    return '';
                }
                if (this.countdown === 0) {
                    return 'now';
                }

                return `in ${this.countdown} sec`;
            },
            scheduleButtonText() {
                return this.hasScheduledCall
                    ? 'Reschedule Your Appointment'
                    : 'Schedule an Appointment for Later';
            },

            ...mapGetters([
                'hasCalendly',
                'hasScheduledCall',
                'directConnectFrom',
                'directConnectFirstCallDelay',
                'leadHash',
                'tenant',
                'isBusinessHours',
                'canInitiateCall',
                'isUnactionable',
            ])
        },

        methods: {
            call() {
                this.scrollToInterface();
                this.$event.$emit('start-call');
            },

            schedule() {
                this.scrollToInterface();
                this.$store.commit('modal', 'schedule-appointment');
            },

            scrollToInterface() {
                const element = document.getElementById('direct-connect-interface');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }
        },
    }
</script>
